var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-wallet-table',{attrs:{"title":_vm.$t('global.models.wallet.heading'),"subtitle":_vm.$t('global.models.wallet.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }